import * as React from "react";
import classNames from "classnames";
import { ProductStatus } from "~/types/product";

export interface ITagProps {
    type?: ProductStatus;
    children: React.ReactNode;
    className?: string;
    shape?: "pill" | "square";
}

export const tagTypeClassMap: { [key in ProductStatus]: string } = {
    NEWS: "news",
    SPOT: "spot",
    BESTSELLER: "bestseller",
    BOOK_OF_THE_MONTH: "botm",
    UPCOMING: "upcoming"
};

const Tag: React.FC<ITagProps> = props => {
    const classModifier = props.type && tagTypeClassMap[props.type];
    const rootClasses = classNames("tag", props.className, `tag--shape-${props.shape || "pill"}`, {
        [`tag--${classModifier}`]: props.type
    });

    return (
        <div className={rootClasses}>
            <span className="tag__label">{props.children}</span>
        </div>
    );
};

export default Tag;
